const Service = () => {
  return (
    <div
      id="service"
      className=" relative w-full h-full px-[calc((100%-var(--container))/2)] 3xl:px-[calc((100%-var(--container)-100px))] py-8 lg:py-16 2xl:py-32"
    >
      <p className="text-[#9E9E9E] mb-10 lg:mb-16">02. 서비스 목록</p>
      <div
        data-aos="fade-right"
        className=" relative w-full h-full grid xl:grid-cols-2 gap-10"
      >
        <div className=" relative w-full h-full bg-white p-5 lg:p-10 rounded-3xl shadow-sm hover:shadow-lg transition-shadow duration-200">
          <h3 className="text-black">
            <span className="font-light">각종</span>&nbsp;도어락&nbsp;해결가능!
          </h3>
          <div className="my-5 text-[var(--gray-color)]">
            <p className="leading-5">
              흔한 도어락 종류부터 흔치않은 도어락까지
            </p>
            <p>없는 도어락빼고 설치, 교체, 해결 가능합니다.</p>
          </div>
          <div className=" px-3 text-[var(--gray-color)] mb-16 lg:mb-24">
            <p>#도어락고장</p>
            <p>#도어락교체</p>
            <p>#도어락설치</p>
            <p>#24시도어락해결</p>
            <p>#도어락비밀번호분실해결</p>
          </div>
          <div>
            <p className="text-black">24시간 해결가능</p>
            <h2 className="manru text-primary text-[35px] md:text-[42px] lg:text-[55px] 2xl:text-6xl">도어락</h2>
          </div>
          <div className=" absolute right-10 bottom-10 w-fit h-fit">
            <img
              className="!relative w-auto h-full max-h-56 lg:max-h-96 3xl:max-h-[450px]"
              src="/images/service1.webp"
              alt="lock"
              width={445}
              height={764}
            />
          </div>
        </div>
        <div
          data-aos="fade-left"
          className=" relative w-full h-full bg-white p-5 lg:p-10 rounded-3xl shadow-sm hover:shadow-lg transition-shadow duration-200"
        >
          <h3 className="text-black">
            <span className="font-light">각종</span>&nbsp;열쇠&nbsp;해결가능!
          </h3>
          <div className="my-5 text-[var(--gray-color)]">
            <p className="leading-5">
              여행가방같은 가벼운 열쇠문제부터 시작해서
            </p>
            <p>화장실, 방문, 현관문 잠김현상도 해결 가능합니다.</p>
          </div>
          <div className=" px-3 text-[var(--gray-color)] mb-16 lg:mb-20">
            <p>#잠긴문해결</p>
            <p>#현관문잠김해결</p>
            <p>#화장실잠김해결</p>
            <p>#금고잠김해결</p>
            <p>#24시출장열쇠</p>
            <p>#24시열쇠</p>
          </div>
          <div>
            <p className="text-black">24시간 해결가능</p>
            <h2 className="manru text-primary text-[35px] md:text-[42px] lg:text-[55px] 2xl:text-6xl">열쇠</h2>
          </div>
          <div className=" absolute right-10 bottom-10 w-fit h-fit">
            <img
              className="!relative w-auto h-full max-h-56 lg:max-h-96 3xl:max-h-[450px]"
              src="/images/service2.webp"
              alt="lock"
              width={516}
              height={711}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Service;
